var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 5822"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3356",
    width: 80,
    height: 80,
    fill: "#5754E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8 32.5455H44.2C44.6418 32.5455 45 32.1995 45 31.7727C45 31.346 44.6418 31 44.2 31H21.8C21.3582 31 21 31.346 21 31.7727C21 32.1995 21.3582 32.5455 21.8 32.5455ZM44.2 40.2727H21.8C21.3582 40.2727 21 39.9268 21 39.5C21 39.0732 21.3582 38.7273 21.8 38.7273H44.2C44.6418 38.7273 45 39.0732 45 39.5C45 39.9268 44.6418 40.2727 44.2 40.2727ZM44.2 48H21.8C21.3582 48 21 47.654 21 47.2273C21 46.8005 21.3582 46.4545 21.8 46.4545H44.2C44.6418 46.4545 45 46.8005 45 47.2273C45 47.654 44.6418 48 44.2 48Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.aa60b52b65416c8bf70c9dd7af4bdd82.svg";
export { ForwardRef as ReactComponent };